<ls-global-loader></ls-global-loader>

<router-outlet></router-outlet>
